import { CSSObject } from '@emotion/react'
import { Spacing } from '@opallabs/gem'

const boxSizing: CSSObject = {
  boxSizing: 'border-box',
  '*': { boxSizing: 'border-box' },
  '*:before': { boxSizing: 'border-box' },
  '*:after': { boxSizing: 'border-box' },
}

export const group: CSSObject = {
  ...boxSizing,
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'nowrap',
  gap: Spacing.XS,
  border: 0,
  padding: 0,
  margin: 0,
}
